__turbopack_context__.v({
  "buttonContainer": "Winners-module__p4MKRW__buttonContainer",
  "carousel": "Winners-module__p4MKRW__carousel",
  "carouselContainer": "Winners-module__p4MKRW__carouselContainer",
  "carouselImageWrapper": "Winners-module__p4MKRW__carouselImageWrapper",
  "carouselItem": "Winners-module__p4MKRW__carouselItem",
  "carouselItemGradient": "Winners-module__p4MKRW__carouselItemGradient",
  "container": "Winners-module__p4MKRW__container",
  "introHeading": "Winners-module__p4MKRW__introHeading",
  "leftColumn": "Winners-module__p4MKRW__leftColumn",
  "polaroid": "Winners-module__p4MKRW__polaroid",
  "polaroidContainer": "Winners-module__p4MKRW__polaroidContainer",
  "polaroids": "Winners-module__p4MKRW__polaroids",
  "prizeInfo": "Winners-module__p4MKRW__prizeInfo",
  "review": "Winners-module__p4MKRW__review",
  "reviewAuthor": "Winners-module__p4MKRW__reviewAuthor",
  "reviewContent": "Winners-module__p4MKRW__reviewContent",
  "rightColumn": "Winners-module__p4MKRW__rightColumn",
  "trustpilotContainer": "Winners-module__p4MKRW__trustpilotContainer",
  "winnersBottomWave": "Winners-module__p4MKRW__winnersBottomWave",
  "winnersBottomWaveDesktop": "Winners-module__p4MKRW__winnersBottomWaveDesktop",
  "winnersBottomWaveMobile": "Winners-module__p4MKRW__winnersBottomWaveMobile",
  "winnersTopWave": "Winners-module__p4MKRW__winnersTopWave",
  "winnersTopWaveDesktop": "Winners-module__p4MKRW__winnersTopWaveDesktop",
  "winnersTopWaveMobile": "Winners-module__p4MKRW__winnersTopWaveMobile",
});
